import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';

class searchFilter extends Component {
    technologyTypeChanged = (selected) => {
      this.props.technologyTypeChanged(selected);
    }

    accessTypeChanged = (selected) => {
      this.props.accessTypeChanged(selected);
    };

    locationChanged = (selected) => {
      this.props.locationChanged(selected);
    };

    notificationTypeChanged = (selected) => {
      this.props.notificationTypeChanged(selected);
    };

    incidentPriorityChanged = (selected) => {
      this.props.incidentPriorityChanged(selected);
    };

    rspChanged = (selected) => {
      this.props.rspChanged(selected);
    };

    sdpChanged = (selected) => {
      this.props.sdpChanged(selected);
    };

    render() {
      return (
        <ul className="list-unstyled text-left h-100 l-height-3">
          <li>
            <div
              className="col-12 d-inline-flex pb-2 px-0"
            >
              <div className="col text-left">
                <div
                  className="text-nowrap text-white"
                >
                                Adjust Filter:
                </div>
              </div>
            </div>
          </li>

          <li className="dropdown">
            <div
              className="col-12 d-inline-flex pt-2 px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        Technology Type
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="technologyType"
                  onChange={this.technologyTypeChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="FTTN" /> FTTN</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="FTTP" /> FTTP</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="FTTC" /> FTTC</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="HFC" /> HFC</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Fixed Wireless" /> Fixed Wireless</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Satellite" /> Satellite</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        Access Type
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="accessType"
                  onChange={this.accessTypeChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="Business" /> Business</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Residential" /> Residential</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Other" /> Other</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        Location
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="location"
                  onChange={this.locationChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="NSW" /> NSW</label>


                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="QLD" /> QLD</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="VIC" /> VIC</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="SA" /> SA</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="WA" /> WA</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="NT" /> NT</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="ACT" /> ACT</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="TAS" /> TAS</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        Notification
                                        Type
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="notificationType"
                  onChange={this.notificationTypeChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="Water Flooding" /> Water Flooding</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Power Leakage" /> Power Leakage</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Gas Leakage" /> Gas Leakage</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Intrusion Detection" /> Intrusion Detection</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        Incident
                                        Priority
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="incidentPriority"
                  onChange={this.incidentPriorityChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="Priority 1" /> Priority 1</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Priority 2" /> Priority 2</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Priority 3" /> Priority 3</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Priority 4" /> Priority 4</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        By RSP
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="rsp"
                  onChange={this.rspChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="Telstra" /> Telstra</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Singtel" /> Singtel</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="M2 Group" /> M2 Group</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
          <li className="dropdown">
            <div
              className="col-12 d-inline-flex px-0"
            >
              <Link
                to="#"
                className="dropdown-toggle w-100"
                id="dropdownMenuButton"
                data-toggle="dropdown"
              >
                <div
                  className="col-12 d-inline-flex px-0"
                >
                  <div
                    className="col text-left"
                  >
                    <div
                      className="text-nowrap text-white"
                    >
                                        By SDP
                    </div>
                  </div>
                  <div
                    className="col text-right"
                  >
                    <div><img
                      src="../../../../../assets/images/dropdown.png"
                    />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="dropdown-menu">
                <CheckboxGroup
                  checkboxDepth={3}
                  name="sdp"
                  onChange={this.sdpChanged}
                >
                  <a className="dropdown-item">
                    <label><Checkbox value="Telstra" /> Telstra</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Optus" /> Optus</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Lend Lease" /> Lend Lease</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Broadspectrum" /> Broadspectrum</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Fulton Hogan" /> Fulton Hogan</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="Downer" /> Downer</label>

                  </a>
                  <a className="dropdown-item">
                    <label><Checkbox value="ISGM" /> ISGM</label>

                  </a>
                </CheckboxGroup>
              </div>
            </div>
          </li>
        </ul>
      );
    }
}

export default searchFilter;



// WEBPACK FOOTER //
// ./components/Header/SearchFilter.js